import React, { useState, useEffect } from "react";
import Lottie from "lottie-react";
import animationData from "../../../assets/animations/tbSuccessfulPaymentAnimation.json";
import { Helmet } from "fusion-plugin-react-helmet-async";
import { assetUrl } from "fusion-core";
import Navbar from "../../../shared/components/navbar";
import Footer from "../../../shared/components/footer";
import QuoteFormWrapper from "../../../shared/components/quoteFormWrapper";
import { useForm } from "react-hook-form";
import useBuyStore from "../store/BuyStore";
import Loader from "../../../shared/components/Loader";
import { useNavigate } from "fusion-plugin-react-router";
import useAppStateStore from "../../../shared/store/AppStateStore";
import { clearAllStores } from "../../../shared/utils/storeUtils";
import { HotjarEventNames } from "../../../shared/utils/hotjarEventNames";
import { TrackHotjarEvent } from "../../../shared/utils/trackHotjarEvent";
import { resetCustomer } from "../../../shared/services/insuranceService";

const css = assetUrl("../../../styles/main.css");
const buyStore = useBuyStore.getState();

const TbPaymentSuccess = () => {
  const [loading, setLoading] = useState(true);
  const [redirectLoading, setRedirectLoading] = useState(false);
  const [formattedResponse, setFormattedResponse] = useState(null);
  const [isErrorResponse, setIsErrorResponse] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [pclResponse, setPclResponse] = useState("");

  const {
    formState: { isValid },
    handleSubmit,
  } = useForm();

  let STATE = useAppStateStore();

  const navigate = useNavigate();
  const userSession = JSON.parse(sessionStorage.getItem("userSession"));
  const uberDriverId = userSession.uberDriverId;

  useEffect(() => {
    TrackHotjarEvent(HotjarEventNames.TAXI_QUOTE_TBPAYMENTSUCCESS_ENTERED);
  }, []);

  useEffect(() => {
    try {
      const storedBuyJourneyData = buyStore.getObject("buyJourneyData");
      if (!storedBuyJourneyData) {
        setLoading(false);
        return;
      }

      const parsedData = JSON.parse(storedBuyJourneyData);
      setSelectedOption(parsedData?.selectedOption || "");
      setPclResponse(parsedData?.pclAgreementData || "");

      const paymentResponse = parsedData?.paymentSuccessResponse;
      if (!paymentResponse) {
        setTimeout(() => setLoading(false), 2000);
        return;
      }

      const parsedResponse = JSON.parse(paymentResponse);
      setFormattedResponse(parsedResponse);
      setIsErrorResponse(!!parsedResponse.error);
    } catch (error) {
      console.error("Error processing payment data:", error);
      setFormattedResponse("Invalid JSON response.");
      setIsErrorResponse(true);
    } finally {
      setLoading(false);
    }
  }, []);

  const financeAgreementAvailable =
    formattedResponse?.IsFinanceAgreementAvailable;
  const policyNumber = formattedResponse?.PolicyNumber;

  const goToPortal = async () => {
    const requestBody = {
      portalLoginProvider: "Uber",
      portalLoginInputs: {
        UberDriverId: uberDriverId,
      },
    };

    try {
      setRedirectLoading(true);

      clearAllStores();

      const responseData = await resetCustomer(requestBody);
      sessionStorage.setItem("userSession", JSON.stringify(responseData));
      navigate("/landing");
    } catch (e) {
      throw e;
    } finally {
      setRedirectLoading(false);
    }
  };

  if (redirectLoading) {
    return <Loader blackbg={true} text="Redirecting to Portal... " />;
  }

  if (loading) {
    return <Loader text="Your payment is in progress... " />;
  }

  return (
    <div>
      <Navbar />
      <form className="mainBody">
        <Helmet>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
          />
          <link rel="stylesheet" href={css} />
        </Helmet>
        <QuoteFormWrapper>
          {isErrorResponse ? (
            <p>An error occurred. Please retry.</p>
          ) : formattedResponse ? (
            <div className="container">
              <div style={{ width: "44px", height: "44px" }} className="">
                <Lottie
                  animationData={animationData}
                  loop={false}
                  autoplay={true}
                  rendererSettings={{
                    preserveAspectRatio: "xMidYMid slice",
                  }}
                  style={{
                    width: "100%",
                    height: "100%",
                    marginLeft: "-7px",
                    marginTop: "-7px",
                  }}
                />
              </div>
              <h3>Payment Successful!</h3>
              <div className="payment-success-div">
                <p className="font-14 margin-bottom-0">
                  You'll receive a confirmation email shortly. For now, continue
                  to the portal where you can see your documents, make changes
                  to your policy, and contact support if you need any help.
                </p>
                {financeAgreementAvailable === true &&
                  selectedOption === "monthly" && (
                    <p className="font-14 margin-bottom-0">
                      You have chosen to go with the Finance option. Your
                      Finance option is currently being reviewed by our Finance
                      partner 'Premium Credit'. You will be contacted in the
                      coming days to complete the agreement.
                    </p>
                  )}
                {financeAgreementAvailable === false &&
                  selectedOption === "monthly" && (
                    <p className="font-14 margin-bottom-0">
                      You have chosen to go with the finance option. Your
                      Finance option is available from our Finance partner
                      'Premium Credit'. You will be contacted in the coming days
                      to complete the agreement.
                    </p>
                  )}
              </div>
              <button
                type="button"
                className="getStartedButton2"
                onClick={() => goToPortal()}
              >
                Go to My Portal
              </button>
              {financeAgreementAvailable === true &&
                selectedOption === "monthly" && (
                  <>
                    <button
                      type="button"
                      className="getStartedButton"
                      onClick={() => {
                        window.location.href = `/agreement/pcl`;
                      }}
                    >
                      Review Agreement
                    </button>
                    <p className="text-gray text-center">
                      Policy number: {policyNumber}
                    </p>
                  </>
                )}
            </div>
          ) : (
            <>
              <button
                type="button"
                className="getStartedButton2"
                onClick={() => goToPortal()}
              >
                Go to My Portal
              </button>
              <p>No payment information available.</p>
            </>
          )}
        </QuoteFormWrapper>
      </form>
      <Footer />
    </div>
  );
};

export default TbPaymentSuccess;
